exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-sm {\n  font-size: 12px;\n}\n.ml-4 {\n  margin-left: 1rem;\n}\n.font-bold {\n  font-weight: bold;\n}\n", ""]);

// exports
